import React from "react";
import styled from "styled-components";

const NoResults = () => {
  return (
    <NoResultDiv>
      <NoResultImage
        src="https://b.zmtcdn.com/data/o2_assets/fffe141958f43b4828cd39f6c69bb21b1707208885.jpeg"
        alt=""
      />
      <NoResultText>No results found!</NoResultText>
    </NoResultDiv>
  );
};

export default NoResults;

const NoResultDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: calc(100vh - 400px);
  min-height: 500px;
  width: 100%;
`;

const NoResultImage = styled.img`
  max-width: 100%;
  width: 300px;
`;

const NoResultText = styled.h1`
  text-align: center;
  font-size: 1.25rem;
`;
